import type { ReactNode } from "react";
import { NavLink } from "react-router-dom";
import { usePermission } from "@/hooks/use-permission";
import { cn } from "@/lib/utils";
import { SettingsLayout } from "../settings-layout";

type TeamSettingsLayoutProps = {
  current: "users" | "profiles";
  actions?: ReactNode;
  children: ReactNode;
};

export function TeamSettingsLayout({ current, actions, children }: TeamSettingsLayoutProps) {
  const { checkPermission } = usePermission();
  const sections = [
    { id: "users", title: "Usuários", to: "/registrations/users", visible: checkPermission("user", "view user") },
    { id: "profiles", title: "Perfis de acesso", to: "/permissions", visible: checkPermission("role", "view role") },
  ];
  return (
    <SettingsLayout current="team" title="Equipe e acessos" lede="Gerencie quem usa o sistema e o que cada perfil pode fazer." actions={actions}>
      <div className="space-y-6">
        <nav aria-label="Seções da equipe" className="flex flex-wrap gap-1 border-b border-app-border pb-3">
          {sections.filter(section => section.visible).map(section => (
            <NavLink key={section.id} to={section.to} aria-current={current === section.id ? "page" : undefined}
              className={cn("inline-flex min-h-11 items-center rounded-lg px-4 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand",
                current === section.id ? "bg-brand-soft font-medium text-brand" : "text-app-fg-muted hover:bg-app-surface-muted")}>
              {section.title}
            </NavLink>
          ))}
        </nav>
        {children}
      </div>
    </SettingsLayout>
  );
}
